<div class="rt-image-editor">
  <label class="d-block cursor-pointer">
    <input (change)="fileChangeEvent($event)" class="input-img" name="avatar" type="file">
  </label>
  @if (previewImage || image) {
    <img
      [src]="previewImage || image"
      alt="avt"
      class="avatar-img"
      [height]="height"
      [width]="width"
      [ngStyle]="{'border-radius': borderRadius + '%'}"
    >
  } @else {
    <rt-icon
      class="avatar-img"
      name="person-circule"
      [height]="height+ 'px'"
      [width]="width + 'px'"
      [ngStyle]="{'border-radius': borderRadius + '%'}"
    >

    </rt-icon>
  }
</div>
